import { useCallback } from 'react'
import { useIntercom } from 'react-use-intercom'

let sessionTerminated = false

export const isIntercomSessionTerminated = () => sessionTerminated

export const useTerminateIntercomSession = () => {
  const { hardShutdown } = useIntercom()

  return useCallback(() => {
    sessionTerminated = true
    hardShutdown()
  }, [hardShutdown])
}

export const __resetIntercomSessionStateForTests = () => {
  sessionTerminated = false
}
